export default "__VITE_PUBLIC_ASSET__0b32c88d__"